import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { NOT_GOING_REASONS } from './helpers';

export const NotGoingDialog = ({ row, onConfirm, onCancel }) => {
  const [reason, setReason] = useState('');
  return (
    <Dialog open={!!row} onOpenChange={(v) => { if (!v) { setReason(''); onCancel(); } }}>
      <DialogContent className="bg-white border-2 border-[#0A0A0A] shadow-[6px_6px_0px_0px_rgba(10,10,10,1)] sm:max-w-[420px]" data-testid="not-going-dialog">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-[#0A0A0A]">Why is {row?.candidate_name} not going?</DialogTitle>
          <DialogDescription className="text-xs text-[#404040]">A reason is required so the team can learn from lost lineups.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-2">
          {NOT_GOING_REASONS.map((r) => (
            <button
              key={r}
              type="button"
              data-testid={`reason-option-${r}`}
              onClick={() => setReason(r)}
              className={`text-left px-3 py-2 border-2 border-black rounded-md font-bold transition-all ${reason === r ? 'bg-[#F87171] text-white -translate-y-0.5 shadow-[2px_2px_0px_0px_rgba(10,10,10,1)]' : 'bg-white text-black hover:bg-[#FEE2E2]'}`}
            >
              {r}
            </button>
          ))}
        </div>
        <Button
          disabled={!reason}
          data-testid="not-going-confirm"
          onClick={() => { onConfirm(reason); setReason(''); }}
          className="w-full bg-[#0A0A0A] text-white border-2 border-black rounded-md font-bold hover:-translate-y-0.5 transition-all disabled:opacity-40"
        >
          Mark as Not Going
        </Button>
      </DialogContent>
    </Dialog>
  );
};
